import React from 'react';
export default function Section({ children, bgColor = 'bg-gray-50' }) {
	return <div className={`h-1/5 py-40 ${bgColor}`}>{children}</div>;
}
